import script from "./ExamPaper2.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamPaper2.vue?vue&type=script&setup=true&lang=js"

import "./ExamPaper2.vue?vue&type=style&index=0&id=6dc317ee&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc317ee"]])

export default __exports__